import {
  MeshStandardMaterial,
  // MeshPhysicalMaterial,
  MeshBasicMaterial,
  // BackSide,
  // sRGBEncoding,
  DoubleSide
} from "three"

import { colours } from "../ApartmentFinderConfig/colours"
// import { colours } from "./config/colours"
// import { isIOS } from "./Helpers"
export const Meshcolours = {
  notActive: "#BE1B38",
  sold: "#B2B2B2",
  hide: "#B2B2B2",
  reserved: "#B2B2B2",
  unreleased: "#5B89B5",
  oneBed: "#B83B47",
  twoBed: "#1F578C",
  threeBed: "#227D4F",
  fourBed: "#DBC555",
  filtered: "#B2B2B2"
}

const favourite = new MeshStandardMaterial({
  // color: "#white",
  color: "#0078D7",
  side: DoubleSide,
  flatShading: true
  // envMapIntensity: isIOS ? 2.6 : 1
})

const notFavourite = new MeshStandardMaterial({
  // color: "#white",
  opacity: 0.1,
  // visible: false,
  transparent: true,
  color: "#000",
  // side: DoubleSide,
  flatShading: true
  // envMapIntensity: isIOS ? 2.6 : 1
})
const one_bed = new MeshStandardMaterial({
  // color: "#white",
  // map: diffuse,
  color: Meshcolours.oneBed,
  side: DoubleSide,
  flatShading: true
  // envMapIntensity: isIOS ? 2.6 : 1
})
const two_bed = new MeshStandardMaterial({
  // color: "#white",
  color: Meshcolours.twoBed,
  flatShading: true,
  side: DoubleSide
  // envMapIntensity: isIOS ? 2.6 : 1
})
const three_bed = new MeshStandardMaterial({
  color: Meshcolours.threeBed,
  side: DoubleSide,
  flatShading: true

  // envMapIntensity: isIOS ? 2.6 : 1
})
const four_bed = new MeshStandardMaterial({
  color: Meshcolours.fourBed,
  side: DoubleSide,
  flatShading: true

  // envMapIntensity: isIOS ? 2.6 : 1
})
const sold_mat = new MeshStandardMaterial({
  // color: "#white",
  color: Meshcolours.sold,
  flatShading: true
  // envMapIntensity: isIOS ? 2.6 : 1
})
const reserved_mat = new MeshStandardMaterial({
  // color: "#white",
  color: Meshcolours.reserved,
  // map: diffuse,
  flatShading: true
  // envMapIntensity: isIOS ? 2.6 : 1
})
const original_mat = new MeshStandardMaterial({
  // color: "#white",
  color: "#0f0",
  // map: diffuse,
  flatShading: true
  // envMapIntensity: isIOS ? 2.6 : 1
})
const hidden_mat = new MeshStandardMaterial({
  // color: "#white",
  color: Meshcolours.hide,
  // map: diffuse,
  flatShading: true
  // envMapIntensity: isIOS ? 2.6 : 1
})

export const getMaterial = (type, isActive, diffuse) => {
  // console.log(type)
  let material

  if (type === "G") {
    material = new MeshStandardMaterial({
      // color: "orange",
      color: "#000",
      roughness: 0,
      opacity: 0.2,
      side: DoubleSide,
      transmission: 1,
      transparent: true,
      reflectivity: 1
    })
    return material
  } else {
    if (isActive) {
      material = new MeshStandardMaterial({
        color: colours.secondaryUI,
        side: DoubleSide,
        flatShading: true,
        envMapIntensity: 0.4
      })
      return material
    } else {
      material = new MeshBasicMaterial({
        map: diffuse,
        side: DoubleSide
        // flatShading: true,
        // envMapIntensity: isIOS ? 2.6 : 1
      })
      return material
    }
  }
}

export const getApartmentMaterial = (
  favouritesActive,
  isInFavourites,
  apartmentFinderActive,
  // isActive,
  beds,
  status,
  inFilter,
  diffuse
) => {
  // console.log(isInFavourites)
  // Window.requestAnimationFrame()
  if (apartmentFinderActive) {
    if (favouritesActive) {
      if (isInFavourites) {
        return favourite
      }
      return notFavourite
    }

    if (inFilter) {
      if (beds === "1") {
        // one_bed.map = diffuse
        return one_bed
      } else if (beds === "2") {
        // two_bed.map = diffuse
        return two_bed
      } else if (beds === "3") {
        // three_bed.map = diffuse
        return three_bed
      } else if (beds === "4") {
        // four_bed.map = diffuse
        return four_bed
      }
    } else if (status === "1") {
      // sold_mat.map = diffuse
      return sold_mat
    } else if (status === "2") {
      // reserved_mat.map = diffuse
      return reserved_mat
    } else {
      // hidden_mat.map = diffuse
      return hidden_mat
    }
  } else {
    original_mat.map = diffuse
    let test = new MeshBasicMaterial({
      map: diffuse
      // color: "#f00"
    })
    // original_mat.color = "#f00"
    return test
  }
}
